var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardMapIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 8.26667C4 6.77333 4 6.02667 4.29067 5.456C4.54633 4.95426 4.95426 4.54633 5.456 4.29067C6.02667 4 6.77333 4 8.26667 4H23.7333C25.2267 4 25.9733 4 26.544 4.29067C27.0457 4.54633 27.4537 4.95426 27.7093 5.456C28 6.02667 28 6.77333 28 8.26667V23.7333C28 25.2267 28 25.9733 27.7093 26.544C27.4537 27.0457 27.0457 27.4537 26.544 27.7093C25.9733 28 25.2267 28 23.7333 28H8.26667C6.77333 28 6.02667 28 5.456 27.7093C4.95426 27.4537 4.54633 27.0457 4.29067 26.544C4 25.9733 4 25.2267 4 23.7333V8.26667Z",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3333 28L20 8.66667M28 8L4 10.6667M17.3333 18.784C17.3333 21.2373 15.0147 22.9773 13.908 23.6693C13.7358 23.7775 13.5367 23.8349 13.3333 23.8349C13.13 23.8349 12.9308 23.7775 12.7587 23.6693C11.652 22.9773 9.33333 21.236 9.33333 18.784C9.33333 16.3133 11.272 14.6667 13.3333 14.6667C15.4667 14.6667 17.3333 16.3133 17.3333 18.784Z",
    stroke: "white",
    strokeWidth: 2.66667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardMapIcon);
export default __webpack_public_path__ + "static/media/dashboardMapIcon.54872b9cfe90f443fccd0b19f9a1194b.svg";
export { ForwardRef as ReactComponent };